import React, {Component} from 'react'
// import { Row, Col, FormControl, Modal, Form, FormGroup, Button } from 'react-bootstrap'
import { Checkbox } from 'react-icheck'
import PrintPreview from '../PrintPreview'
import FontAwesome from 'react-fontawesome'
import WorkdocStore from 'stores/WorkdocStore'
import PdfStore from 'stores/PdfStore'
import TextFieldModal from 'component/element/TextFieldModal'
import { QRCode } from 'react-qr-svg'
import './Print.css'

var NotificationSystem = require('react-notification-system')
const FIXED_LISTS = [
    {seq:'1',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'2',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'3',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'4',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'5',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'6',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'7',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'8',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'9',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'10',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'11',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'12',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'13',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'14',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'15',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'16',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'17',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'18',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'19',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'20',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'21',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'22',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'23',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'24',in:'',out:'',remark:''},
    {seq:'25',e:undefined,_1:undefined,_3:undefined,f:undefined,remark:''},
    {seq:'26',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'27',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'28',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'29',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'30',before_repair:undefined,after_repair:undefined,remark:''},
    {seq:'31',before_repair:undefined,after_repair:undefined,remark:''}
]
class PrintWCSCheckingCarDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {
        loading:false,
        data:[],
        related_detail_wcs:{fiexd_lists:FIXED_LISTS,customer_permission:undefined,remark:''},
        page_title:'กำลังดึงข้อมูล..',
        check_click:undefined
    }
    
    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
    this.loadData()
  }

  loadData() {
    let {workNo} = this.props
    let {related_detail_wcs} = this.state
    PdfStore.loadCheckingCarDoc(workNo,'wcs_checking_car_doc',(result)=>{
      
      if (typeof result.data.fiexd_lists==='undefined'||typeof result.data.customer_permission==='undefined'||typeof result.data.remark==='undefined') {
        related_detail_wcs.fiexd_lists = FIXED_LISTS
        related_detail_wcs.customer_permission = undefined
        related_detail_wcs.remark = ''
      } else {
        related_detail_wcs = result.data.related_detail
      }
      this.setState({data:result.data,page_title:'ไม่พบข้อมูล',related_detail_wcs:related_detail_wcs})  
    }) 
  }

  onCheckClick(field) {
    let {check_click} = this.state
    if (check_click===undefined) {
        check_click = field
    } else {
        if (check_click===field)
            check_click = undefined
        else
            check_click = field    
    }
    this.setState({check_click:check_click})
    if (check_click!==undefined) {
        this._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'เลือกเครื่องหมาย "'+(check_click===false?'ไม่ผ่าน':'ผ่าน')+'"',
            level: 'info',
            position: 'tc',        
        })
    } else {
        this._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'ยกเลิกการเลือกเครื่องหมาย',
            level: 'info',
            position: 'tc',        
        })
    }
  }

  onCheck(index,field) {
    let {related_detail_wcs,check_click} = this.state
    if (check_click===undefined) {
        this._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'กรุณาเลือกเครื่องหมาย',
            level: 'error',
            position: 'tc',        
        })
    } else {
        if (check_click) {
            if (related_detail_wcs.fiexd_lists[index][field]===check_click) {
                related_detail_wcs.fiexd_lists[index][field] = undefined
            } else {
                related_detail_wcs.fiexd_lists[index][field] = true
            }
        } else if (check_click===false) {
            if (related_detail_wcs.fiexd_lists[index][field]===check_click) {
                related_detail_wcs.fiexd_lists[index][field] = undefined
            } else {
                related_detail_wcs.fiexd_lists[index][field] = false
            }
        }
    }
    this.setState({related_detail_wcs:related_detail_wcs})
    this.saveDoc()
  }

  onMilesClick(value,index,field,e) {
    let fieldInfo = {title:'เลขไมล์'+(field==='in'?'ก่อนซ่อม':'หลังซ่อม'),showClear:false,value:value,key:field}
    this.refs.milesFieldModal.loadInfo(fieldInfo)
  }

  onMilesSave(items) {
    let {related_detail_wcs} = this.state
    related_detail_wcs.fiexd_lists[23][items.key] = items.value
    this.setState({related_detail_wcs:related_detail_wcs})
    this.saveDoc()
  }

  onRemarkClick(value,e) {
    let fieldInfo = {title:'หมายเหตุ',showClear:false,value:value}
    this.refs.remarkFieldModal.loadInfo(fieldInfo)
  }

  onRemarkSave(items) {
    let {related_detail_wcs} = this.state
    related_detail_wcs.remark = items.value
    this.setState({related_detail_wcs:related_detail_wcs})
    this.saveDoc()
  }

  onSubRemarkClick(value,index,e) {
    let fieldInfo = {title:'หมายเหตุ',showClear:false,value:value,index:index}
    this.refs.subRemarkFieldModal.loadInfo(fieldInfo)
  }

  onSubRemarkSave(items) {
    let {related_detail_wcs} = this.state
    related_detail_wcs.fiexd_lists[items.index].remark = items.value
    this.setState({related_detail_wcs:related_detail_wcs})
    this.saveDoc()
  }

  onFuelChange(field) {
    let {related_detail_wcs} = this.state
    if (related_detail_wcs.fiexd_lists[24][field]) {
        related_detail_wcs.fiexd_lists[24][field] = undefined
    } else {
        related_detail_wcs.fiexd_lists[24][field] = true
    }

    if (field==='e') {
        related_detail_wcs.fiexd_lists[24]._1 = undefined
        related_detail_wcs.fiexd_lists[24]._3 = undefined
        related_detail_wcs.fiexd_lists[24].f = undefined
    } else if (field==='_1') {
        related_detail_wcs.fiexd_lists[24].e = undefined
        related_detail_wcs.fiexd_lists[24]._3 = undefined
        related_detail_wcs.fiexd_lists[24].f = undefined
    } else if (field==='_3') {
        related_detail_wcs.fiexd_lists[24]._1 = undefined
        related_detail_wcs.fiexd_lists[24].e = undefined
        related_detail_wcs.fiexd_lists[24].f = undefined
    } else if (field==='f') {
        related_detail_wcs.fiexd_lists[24]._1 = undefined
        related_detail_wcs.fiexd_lists[24]._3 = undefined
        related_detail_wcs.fiexd_lists[24].e = undefined
    }
    this.setState({related_detail_wcs:related_detail_wcs})
    this.saveDoc()
  }

  onCheckChange(index,field,value) {
    let {related_detail_wcs} = this.state
    if (value&&value!==related_detail_wcs.fiexd_lists[index][field]) {
        related_detail_wcs.fiexd_lists[index][field] = true
    } else if (related_detail_wcs.fiexd_lists[index][field]===value) {
        related_detail_wcs.fiexd_lists[index][field] = undefined
    } else {
        related_detail_wcs.fiexd_lists[index][field] = false
    }

    this.setState({related_detail_wcs:related_detail_wcs})
    this.saveDoc()
  }

  onCustomerPermissionChange(value) {
    let {related_detail_wcs} = this.state
    if (value&&value!==related_detail_wcs.customer_permission)
        related_detail_wcs.customer_permission = true
    else if (related_detail_wcs.customer_permission===value)
        related_detail_wcs.customer_permission = undefined
    else
        related_detail_wcs.customer_permission = false  
    
    this.setState({related_detail_wcs:related_detail_wcs})
    this.saveDoc()    
  }

  saveDoc() {
    let {workNo} = this.props
    let {related_detail_wcs} = this.state
    WorkdocStore.saveWorkdocRelated(workNo,'wcs_checking_car_doc',related_detail_wcs,(result) => {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียดเอกสารประกอบเลขงานซ่อม ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc',        
      })
    },(result) => {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีความผิดพลาดเกิดขึ้นในการบันทึกเอกสารประกอบเลขงานซ่อม ' + workNo + ' ',
        level: 'error',
        position: 'tc'
      })
    })
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  renderCheck() {
    let {related_detail_wcs,check_click} = this.state
    return(
        <div>
            <div className='wcs-check-header bg'>
                ภายนอก
            </div>
            <div className='wcs-check-header'>
                1. สีรถ (ขีดข่วน=1, ครูด=2, บุบ=3, ระยะห่างช่องไฟ=4, ความเหมือนของสีเก่า/ใหม่=5)
                <span className='float-right'><i onClick={this.onCheckClick.bind(this,true)} className={'cursor-pointer fa fa-check'+(check_click?' color-green':'')}></i> ผ่าน <i onClick={this.onCheckClick.bind(this,false)} className={'cursor-pointer fa fa-close'+(check_click===false?' color-red':'')}></i> ไม่ผ่าน</span>
            </div>
            <div className='wcs-check-header'>
                <table className='table table-print-wcs-parking-car-doc' style={{marginBottom:'0'}}>
                    <tbody>
                        <tr>
                            <td style={{verticalAlign:'bottom'}} rowSpan={2} className='text-left fixed-list'>1. ประตูหน้า ขวา</td>
                            <td className='text-center font-10'>ก่อนซ่อม/หลังซ่อม</td>
                            <td style={{verticalAlign:'bottom'}} rowSpan={2} className='text-left fixed-list'>5. บังโคลนหหน้า ซ้าย</td>
                            <td className='text-center font-10'>ก่อนซ่อม/หลังซ่อม</td>
                            <td style={{verticalAlign:'bottom'}} rowSpan={2} className='text-left fixed-list'>9. แผงข้าง/บังโคลนหลังซ้าย</td>
                            <td className='text-center font-10'>ก่อนซ่อม/หลังซ่อม</td>
                            <td style={{verticalAlign:'bottom'}} rowSpan={2} className='text-left fixed-list'>13. ประตูหลัง/แค๊ปขวา</td>
                            <td className='text-center font-10'>ก่อนซ่อม/หลังซ่อม</td>
                        </tr>
                        <tr>
                            <td className='text-center check'>
                                <div onClick={this.onCheck.bind(this,0,'before_repair')}>{related_detail_wcs.fiexd_lists[0].before_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[0].before_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                                <div onClick={this.onCheck.bind(this,0,'after_repair')}>{related_detail_wcs.fiexd_lists[0].after_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[0].after_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                            </td>
                            <td className='text-center check'>
                                <div onClick={this.onCheck.bind(this,4,'before_repair')}>{related_detail_wcs.fiexd_lists[4].before_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[4].before_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                                <div onClick={this.onCheck.bind(this,4,'after_repair')}>{related_detail_wcs.fiexd_lists[4].after_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[4].after_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                            </td>
                            <td className='text-center check'>
                                <div onClick={this.onCheck.bind(this,8,'before_repair')}>{related_detail_wcs.fiexd_lists[8].before_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[8].before_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                                <div onClick={this.onCheck.bind(this,8,'after_repair')}>{related_detail_wcs.fiexd_lists[8].after_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[8].after_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                            </td>
                            <td className='text-center check'>
                                <div onClick={this.onCheck.bind(this,12,'before_repair')}>{related_detail_wcs.fiexd_lists[12].before_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[12].before_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                                <div onClick={this.onCheck.bind(this,12,'after_repair')}>{related_detail_wcs.fiexd_lists[12].after_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[12].after_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                            </td>
                        </tr>
                        <tr>
                            <td style={{verticalAlign:'bottom'}} rowSpan={2} className='text-left fixed-list'>2. บังโคลนหหน้า ขวา</td>
                            <td className='text-center font-10'>ก่อนซ่อม/หลังซ่อม</td>
                            <td style={{verticalAlign:'bottom'}} rowSpan={2} className='text-left fixed-list'>6. ประตูหน้า ซ้าย</td>
                            <td className='text-center font-10'>ก่อนซ่อม/หลังซ่อม</td>
                            <td style={{verticalAlign:'bottom'}} rowSpan={2} className='text-left fixed-list'>10. ฝากระโปรงหลัง/ฝาปิดท้าย</td>
                            <td className='text-center font-10'>ก่อนซ่อม/หลังซ่อม</td>
                            <td style={{verticalAlign:'bottom'}} rowSpan={2} className='text-left fixed-list'>14. บันไดขวา</td>
                            <td className='text-center font-10'>ก่อนซ่อม/หลังซ่อม</td>
                        </tr>
                        <tr>
                            <td className='text-center check'>
                                <div onClick={this.onCheck.bind(this,1,'before_repair')}>{related_detail_wcs.fiexd_lists[1].before_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[1].before_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                                <div onClick={this.onCheck.bind(this,1,'after_repair')}>{related_detail_wcs.fiexd_lists[1].after_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[1].after_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                            </td>
                            <td className='text-center check'>
                                <div onClick={this.onCheck.bind(this,5,'before_repair')}>{related_detail_wcs.fiexd_lists[5].before_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[5].before_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                                <div onClick={this.onCheck.bind(this,5,'after_repair')}>{related_detail_wcs.fiexd_lists[5].after_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[5].after_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                            </td>
                            <td className='text-center check'>
                                <div onClick={this.onCheck.bind(this,9,'before_repair')}>{related_detail_wcs.fiexd_lists[9].before_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[9].before_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                                <div onClick={this.onCheck.bind(this,9,'after_repair')}>{related_detail_wcs.fiexd_lists[9].after_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[9].after_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                            </td>
                            <td className='text-center check'>
                                <div onClick={this.onCheck.bind(this,13,'before_repair')}>{related_detail_wcs.fiexd_lists[13].before_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[13].before_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                                <div onClick={this.onCheck.bind(this,13,'after_repair')}>{related_detail_wcs.fiexd_lists[13].after_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[13].after_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                            </td>
                        </tr>
                        <tr>
                            <td style={{verticalAlign:'bottom'}} rowSpan={2} className='text-left fixed-list'>3. ฝากระโปรงหน้า</td>
                            <td className='text-center font-10'>ก่อนซ่อม/หลังซ่อม</td>
                            <td style={{verticalAlign:'bottom'}} rowSpan={2} className='text-left fixed-list'>7. ประตูหลัง/แค๊ปซ้าย</td>
                            <td className='text-center font-10'>ก่อนซ่อม/หลังซ่อม</td>
                            <td style={{verticalAlign:'bottom'}} rowSpan={2} className='text-left fixed-list'>11. กันชนหลัง</td>
                            <td className='text-center font-10'>ก่อนซ่อม/หลังซ่อม</td>
                            <td style={{verticalAlign:'bottom'}} rowSpan={2} className='text-left fixed-list'>15. หลังคา</td>
                            <td className='text-center font-10'>ก่อนซ่อม/หลังซ่อม</td>
                        </tr>
                        <tr>
                            <td className='text-center check'>
                                <div onClick={this.onCheck.bind(this,2,'before_repair')}>{related_detail_wcs.fiexd_lists[2].before_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[2].before_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                                <div onClick={this.onCheck.bind(this,2,'after_repair')}>{related_detail_wcs.fiexd_lists[2].after_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[2].after_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                            </td>
                            <td className='text-center check'>
                                <div onClick={this.onCheck.bind(this,6,'before_repair')}>{related_detail_wcs.fiexd_lists[6].before_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[6].before_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                                <div onClick={this.onCheck.bind(this,6,'after_repair')}>{related_detail_wcs.fiexd_lists[6].after_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[6].after_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                            </td>
                            <td className='text-center check'>
                                <div onClick={this.onCheck.bind(this,10,'before_repair')}>{related_detail_wcs.fiexd_lists[10].before_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[10].before_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                                <div onClick={this.onCheck.bind(this,10,'after_repair')}>{related_detail_wcs.fiexd_lists[10].after_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[10].after_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                            </td>
                            <td className='text-center check'>
                                <div onClick={this.onCheck.bind(this,14,'before_repair')}>{related_detail_wcs.fiexd_lists[14].before_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[14].before_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                                <div onClick={this.onCheck.bind(this,14,'after_repair')}>{related_detail_wcs.fiexd_lists[14].after_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[14].after_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                            </td>
                        </tr>
                        <tr>
                            <td style={{verticalAlign:'bottom'}} rowSpan={2} className='text-left fixed-list'>4. กันชนหน้า</td>
                            <td className='text-center font-10'>ก่อนซ่อม/หลังซ่อม</td>
                            <td style={{verticalAlign:'bottom'}} rowSpan={2} className='text-left fixed-list'>8. บันไดซ้าย</td>
                            <td className='text-center font-10'>ก่อนซ่อม/หลังซ่อม</td>
                            <td style={{verticalAlign:'bottom'}} rowSpan={2} className='text-left fixed-list'>12. แผงข้าง/บังโคลนหลังขวา</td>
                            <td className='text-center font-10'>ก่อนซ่อม/หลังซ่อม</td>
                            <td style={{verticalAlign:'bottom'}} rowSpan={2} className='text-left fixed-list'>16. อื่นๆ...............</td>
                            <td className='text-center font-10'>ก่อนซ่อม/หลังซ่อม</td>
                        </tr>
                        <tr>
                            <td className='text-center check'>
                                <div onClick={this.onCheck.bind(this,3,'before_repair')}>{related_detail_wcs.fiexd_lists[3].before_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[3].before_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                                <div onClick={this.onCheck.bind(this,3,'after_repair')}>{related_detail_wcs.fiexd_lists[3].after_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[3].after_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                            </td>
                            <td className='text-center check'>
                                <div onClick={this.onCheck.bind(this,7,'before_repair')}>{related_detail_wcs.fiexd_lists[7].before_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[7].before_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                                <div onClick={this.onCheck.bind(this,7,'after_repair')}>{related_detail_wcs.fiexd_lists[7].after_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[7].after_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                            </td>
                            <td className='text-center check'>
                                <div onClick={this.onCheck.bind(this,11,'before_repair')}>{related_detail_wcs.fiexd_lists[11].before_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[11].before_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                                <div onClick={this.onCheck.bind(this,11,'after_repair')}>{related_detail_wcs.fiexd_lists[11].after_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[11].after_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                            </td>
                            <td className='text-center check'>
                                <div onClick={this.onCheck.bind(this,15,'before_repair')}>{related_detail_wcs.fiexd_lists[15].before_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[15].before_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                                <div onClick={this.onCheck.bind(this,15,'after_repair')}>{related_detail_wcs.fiexd_lists[15].after_repair?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-check' />:related_detail_wcs.fiexd_lists[15].after_repair===false?<i style={{position:'absolute',right:'0',left:'0',top:'0',bottom:'0',fontSize:'14px'}} className='fa fa-close' />:''}</div>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={8} className='remark' onClick={this.onRemarkClick.bind(this,related_detail_wcs.remark)}>หมายเหตุ <span>{related_detail_wcs.remark}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='wcs-check-header p-0'>
                <table className='table table-print-wcs-parking-car-check' style={{marginBottom:'0',border:'hidden'}}>
                    <tbody>
                        <tr>
                            <td style={{width:'380px'}} rowSpan={2} className='bg text-left'></td>
                            <td colSpan={2} className='text-center font-12 bg'>ก่อนซ่อม</td>
                            <td colSpan={2} className='text-center font-12 bg'>หลังซ่อม</td>
                            <td style={{width:'100px',verticalAlign:'middle'}} rowSpan={2} className='bg text-center'>หมายเหตุ</td>
                        </tr>
                        <tr>
                            <td style={{width:'30px'}} className='text-center font-12 bg'>ผ่าน</td>
                            <td style={{width:'30px'}} className='text-center font-12 bg'>ไม่ผ่าน</td>
                            <td style={{width:'30px'}} className='text-center font-12 bg'>ผ่าน</td>
                            <td style={{width:'30px'}} className='text-center font-12 bg'>ไม่ผ่าน</td>
                        </tr>
                        <tr>
                            <td className='text-left fixed-list'>17. ยางล้อ (ปียางที่ผลิต, ขนาดยาง, MAX, ยี่ห้อ)</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,16,'before_repair',true)}>{related_detail_wcs.fiexd_lists[16].before_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,16,'before_repair',false)}>{related_detail_wcs.fiexd_lists[16].before_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,16,'after_repair',true)}>{related_detail_wcs.fiexd_lists[16].after_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,16,'after_repair',false)}>{related_detail_wcs.fiexd_lists[16].after_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-left remark' onClick={this.onSubRemarkClick.bind(this,related_detail_wcs.fiexd_lists[16].remark,16)}><div>{related_detail_wcs.fiexd_lists[16].remark}</div></td>
                        </tr>
                        <tr>
                            <td className='text-left fixed-list'>18. กระจกบังลมหน้า/หลัง</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,17,'before_repair',true)}>{related_detail_wcs.fiexd_lists[17].before_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,17,'before_repair',false)}>{related_detail_wcs.fiexd_lists[17].before_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,17,'after_repair',true)}>{related_detail_wcs.fiexd_lists[17].after_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,17,'after_repair',false)}>{related_detail_wcs.fiexd_lists[17].after_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-left remark' onClick={this.onSubRemarkClick.bind(this,related_detail_wcs.fiexd_lists[17].remark,17)}><div>{related_detail_wcs.fiexd_lists[17].remark}</div></td>
                        </tr>
                        <tr>
                            <td className='text-left fixed-list'>19. ไฟหน้า, ไฟหลัง, ไฟเบรค, ไฟเลี้ยว, ไฟตัดหมอก)</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,18,'before_repair',true)}>{related_detail_wcs.fiexd_lists[18].before_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,18,'before_repair',false)}>{related_detail_wcs.fiexd_lists[18].before_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,18,'after_repair',true)}>{related_detail_wcs.fiexd_lists[18].after_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,18,'after_repair',false)}>{related_detail_wcs.fiexd_lists[18].after_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-left remark' onClick={this.onSubRemarkClick.bind(this,related_detail_wcs.fiexd_lists[18].remark,18)}><div>{related_detail_wcs.fiexd_lists[18].remark}</div></td>
                        </tr>
                        <tr>
                            <td className='text-left fixed-list'>20. ฝากระโปรงหน้า, หลัง ทดสอบการเปิด ปิด</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,19,'before_repair',true)}>{related_detail_wcs.fiexd_lists[19].before_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,19,'before_repair',false)}>{related_detail_wcs.fiexd_lists[19].before_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,19,'after_repair',true)}>{related_detail_wcs.fiexd_lists[19].after_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,19,'after_repair',false)}>{related_detail_wcs.fiexd_lists[19].after_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-left remark' onClick={this.onSubRemarkClick.bind(this,related_detail_wcs.fiexd_lists[19].remark,19)}><div>{related_detail_wcs.fiexd_lists[19].remark}</div></td>
                        </tr>
                        <tr>
                            <td className='text-left fixed-list'>21. แบตเตอรี่ ยี่ห้อ/ขนาด</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,20,'before_repair',true)}>{related_detail_wcs.fiexd_lists[20].before_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,20,'before_repair',false)}>{related_detail_wcs.fiexd_lists[20].before_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,20,'after_repair',true)}>{related_detail_wcs.fiexd_lists[20].after_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,20,'after_repair',false)}>{related_detail_wcs.fiexd_lists[20].after_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-left remark' onClick={this.onSubRemarkClick.bind(this,related_detail_wcs.fiexd_lists[20].remark,20)}><div>{related_detail_wcs.fiexd_lists[20].remark}</div></td>
                        </tr>
                        <tr>
                            <td className='text-left fixed-list'>22. แม่แรง, ยางอะไหล่, เครื่องมือ</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,21,'before_repair',true)}>{related_detail_wcs.fiexd_lists[21].before_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,21,'before_repair',false)}>{related_detail_wcs.fiexd_lists[21].before_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,21,'after_repair',true)}>{related_detail_wcs.fiexd_lists[21].after_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,21,'after_repair',false)}>{related_detail_wcs.fiexd_lists[21].after_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-left remark' onClick={this.onSubRemarkClick.bind(this,related_detail_wcs.fiexd_lists[21].remark,21)}><div>{related_detail_wcs.fiexd_lists[21].remark}</div></td>
                        </tr>    
                    </tbody>    
                </table>
            </div>
            <div className='wcs-check-header p-0'>
                <table className='table table-print-wcs-parking-car-check' style={{marginBottom:'0',border:'hidden'}}>
                    <tbody>
                        <tr>
                            <td style={{width:'380px',verticalAlign:'middle'}} rowSpan={2} className='bg text-left'>ภายใน</td>
                            <td colSpan={2} className='text-center font-12 bg'>ก่อนซ่อม</td>
                            <td colSpan={2} className='text-center font-12 bg'>หลังซ่อม</td>
                            <td style={{width:'100px',verticalAlign:'middle'}} rowSpan={2} className='bg text-center'>หมายเหตุ</td>
                        </tr>
                        <tr>
                            <td style={{width:'30px'}} className='text-center font-12 bg'>ผ่าน</td>
                            <td style={{width:'30px'}} className='text-center font-12 bg'>ไม่ผ่าน</td>
                            <td style={{width:'30px'}} className='text-center font-12 bg'>ผ่าน</td>
                            <td style={{width:'30px'}} className='text-center font-12 bg'>ไม่ผ่าน</td>
                        </tr>
                        <tr>
                            <td className='text-left fixed-list'>23. เบาะ เลอะ/ขาดหรือไม่</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,22,'before_repair',true)}>{related_detail_wcs.fiexd_lists[22].before_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,22,'before_repair',false)}>{related_detail_wcs.fiexd_lists[22].before_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,22,'after_repair',true)}>{related_detail_wcs.fiexd_lists[22].after_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,22,'after_repair',false)}>{related_detail_wcs.fiexd_lists[22].after_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-left remark' onClick={this.onSubRemarkClick.bind(this,related_detail_wcs.fiexd_lists[22].remark,22)}><div>{related_detail_wcs.fiexd_lists[22].remark}</div></td>
                        </tr>
                        <tr>
                            <td className='text-left fixed-list'>24. ระบุเลขไมล์</td>
                            <td colSpan={2} className='text-center cursor-pointer' onClick={this.onMilesClick.bind(this,related_detail_wcs.fiexd_lists[23].in,23,'in')}>
                                <div style={{position:'relative'}}>{related_detail_wcs.fiexd_lists[23].in}<small className='fuel-level'>IN</small></div>
                            </td>
                            <td colSpan={2} className='text-center cursor-pointer' onClick={this.onMilesClick.bind(this,related_detail_wcs.fiexd_lists[23].out,23,'out')}>
                                <div style={{position:'relative'}}>{related_detail_wcs.fiexd_lists[23].out}<small className='fuel-level'>OUT</small></div>
                            </td>
                            <td className='text-left remark' onClick={this.onSubRemarkClick.bind(this,related_detail_wcs.fiexd_lists[16].remark,23)}><div>{related_detail_wcs.fiexd_lists[23].remark}</div></td>
                        </tr>
                        <tr>
                            <td className='text-left fixed-list'>25. ระดับน้ำมันเชื้อเพลิง ระบุเกจ์วัด</td>
                            <td className='text-center cursor-pointer' onClick={this.onFuelChange.bind(this,'e')}>
                                <div style={{position:'relative'}}>{related_detail_wcs.fiexd_lists[24].e?<FontAwesome name='check' />:''}<small className='fuel-level'>E</small></div>
                            </td>
                            <td className='text-center cursor-pointer' onClick={this.onFuelChange.bind(this,'_1')}>
                                <div style={{position:'relative'}}>{related_detail_wcs.fiexd_lists[24]._1?<FontAwesome name='check' />:''}<small className='fuel-level'>1/4</small></div>
                            </td>
                            <td className='text-center cursor-pointer' onClick={this.onFuelChange.bind(this,'_3')}>
                                <div style={{position:'relative'}}>{related_detail_wcs.fiexd_lists[24]._3?<FontAwesome name='check' />:''}<small className='fuel-level'>3/4</small></div>
                            </td>
                            <td className='text-center cursor-pointer' onClick={this.onFuelChange.bind(this,'f')}>
                                <div style={{position:'relative'}}>{related_detail_wcs.fiexd_lists[24].f?<FontAwesome name='check' />:''}<small className='fuel-level'>F</small></div>
                            </td>
                            <td className='text-left remark' onClick={this.onSubRemarkClick.bind(this,related_detail_wcs.fiexd_lists[24].remark,24)}><div>{related_detail_wcs.fiexd_lists[24].remark}</div></td>
                        </tr>
                        <tr>
                            <td className='text-left fixed-list'>26. กล่องเก็บของหน้ารถ มีทรัพย์สินมีค่าหรือไม่</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,25,'before_repair',true)}>{related_detail_wcs.fiexd_lists[25].before_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,25,'before_repair',false)}>{related_detail_wcs.fiexd_lists[25].before_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,25,'after_repair',true)}>{related_detail_wcs.fiexd_lists[25].after_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,25,'after_repair',false)}>{related_detail_wcs.fiexd_lists[25].after_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-left remark' onClick={this.onSubRemarkClick.bind(this,related_detail_wcs.fiexd_lists[25].remark,25)}><div>{related_detail_wcs.fiexd_lists[25].remark}</div></td>
                        </tr>
                        <tr>
                            <td className='text-left fixed-list'>27. กล่องเก็บของที่นั่งผู้ขับ มีทรัพย์สินมีค่าหรือไม่</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,26,'before_repair',true)}>{related_detail_wcs.fiexd_lists[26].before_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,26,'before_repair',false)}>{related_detail_wcs.fiexd_lists[26].before_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,26,'after_repair',true)}>{related_detail_wcs.fiexd_lists[26].after_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,26,'after_repair',false)}>{related_detail_wcs.fiexd_lists[26].after_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-left remark' onClick={this.onSubRemarkClick.bind(this,related_detail_wcs.fiexd_lists[26].remark,26)}><div>{related_detail_wcs.fiexd_lists[26].remark}</div></td>
                        </tr>  
                    </tbody>    
                </table>
            </div>  
            <div className='wcs-check-header p-0'>
                <table className='table table-print-wcs-parking-car-check' style={{marginBottom:'0',border:'hidden'}}>
                    <tbody>
                        <tr>
                            <td style={{width:'380px',verticalAlign:'middle'}} rowSpan={2} className='bg text-left'>ระบบไฟฟ้า</td>
                            <td colSpan={2} className='text-center font-12 bg'>ก่อนซ่อม</td>
                            <td colSpan={2} className='text-center font-12 bg'>หลังซ่อม</td>
                            <td style={{width:'100px',verticalAlign:'middle'}} rowSpan={2} className='text-center bg'>หมายเหตุ</td>
                        </tr>
                        <tr>
                            <td style={{width:'30px'}} className='text-center font-12 bg'>ผ่าน</td>
                            <td style={{width:'30px'}} className='text-center font-12 bg'>ไม่ผ่าน</td>
                            <td style={{width:'30px'}} className='text-center font-12 bg'>ผ่าน</td>
                            <td style={{width:'30px'}} className='text-center font-12 bg'>ไม่ผ่าน</td>
                        </tr>
                        <tr>
                            {/* <td className='text-left fixed-list'>28. <span className='font-12'>ไฟสูง-ต่ำ, ไฟตัดหมอก, ไฟหรี่, ไฟเลี้ยว, ไฟขอทาง, ไฟเก๋ง, ไฟเบรค, ไฟเบรคดวงที่สาม</span></td> */}
                            <td className='text-left fixed-list'>28. ไฟสูง-ต่ำ, ไฟตัดหมอก, ไฟหรี่, ไฟเลี้ยว, ไฟขอทาง, ไฟเก๋ง, ไฟเบรค, ไฟเบรคดวงที่สาม</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,27,'before_repair',true)}>{related_detail_wcs.fiexd_lists[27].before_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,27,'before_repair',false)}>{related_detail_wcs.fiexd_lists[27].before_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,27,'after_repair',true)}>{related_detail_wcs.fiexd_lists[27].after_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,27,'after_repair',false)}>{related_detail_wcs.fiexd_lists[27].after_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-left remark' onClick={this.onSubRemarkClick.bind(this,related_detail_wcs.fiexd_lists[27].remark,27)}><div>{related_detail_wcs.fiexd_lists[27].remark}</div></td>
                        </tr>
                        <tr>
                            <td className='text-left fixed-list'>29. กระจกมองข้าง พับได้ปกติ</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,28,'before_repair',true)}>{related_detail_wcs.fiexd_lists[28].before_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,28,'before_repair',false)}>{related_detail_wcs.fiexd_lists[28].before_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,28,'after_repair',true)}>{related_detail_wcs.fiexd_lists[28].after_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,28,'after_repair',false)}>{related_detail_wcs.fiexd_lists[28].after_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-left remark' onClick={this.onSubRemarkClick.bind(this,related_detail_wcs.fiexd_lists[28].remark,28)}><div>{related_detail_wcs.fiexd_lists[28].remark}</div></td>
                        </tr>
                        <tr>
                            <td className='text-left fixed-list'>30. แตร, ที่ปัดน้ำฝน</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,29,'before_repair',true)}>{related_detail_wcs.fiexd_lists[29].before_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,29,'before_repair',false)}>{related_detail_wcs.fiexd_lists[29].before_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,29,'after_repair',true)}>{related_detail_wcs.fiexd_lists[29].after_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,29,'after_repair',false)}>{related_detail_wcs.fiexd_lists[29].after_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-left remark' onClick={this.onSubRemarkClick.bind(this,related_detail_wcs.fiexd_lists[29].remark,29)}><div>{related_detail_wcs.fiexd_lists[29].remark}</div></td>
                        </tr>
                        <tr>
                            <td className='text-left fixed-list'>31. กุญแจรีโมท, รีโมทคอนโทรล</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,30,'before_repair',true)}>{related_detail_wcs.fiexd_lists[30].before_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,30,'before_repair',false)}>{related_detail_wcs.fiexd_lists[30].before_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,30,'after_repair',true)}>{related_detail_wcs.fiexd_lists[30].after_repair?<FontAwesome name='check' />:''}</td>
                            <td className='text-center cursor-pointer' onClick={this.onCheckChange.bind(this,30,'after_repair',false)}>{related_detail_wcs.fiexd_lists[30].after_repair===false?<FontAwesome name='check' />:''}</td>
                            <td className='text-left remark' onClick={this.onSubRemarkClick.bind(this,related_detail_wcs.fiexd_lists[30].remark,30)}><div>{related_detail_wcs.fiexd_lists[30].remark}</div></td>
                        </tr>
                    </tbody>    
                </table>
            </div>
        </div>
    )
  }

  renderSignature() {
    return(
        <div className='text-center other-text'>
            <div>
                <table className='table table-print-wcs-parking-car-doc'>
                    <tbody>
                        <tr>
                            <td className='text-center'>............................................................................</td>
                        </tr>
                        <tr>
                            <td className='text-center'>เจ้าของ/ผู้นำรถเข้าซ่อม</td>
                        </tr>
                    </tbody>
                </table>
            </div>  
        </div>
    )
  }

  renderQRCode() {
    return(
            <div className='box-qr-code text-left'>
                <div style={{display:'inline-flex'}}>
                    <div>
                        <QRCode
                            bgColor="#FFFFFF"
                            fgColor="#111000"
                            level="Q"
                            style={{width:70}}
                            value={'www.google.com'}
                        />
                    </div>
                    &nbsp;    
                    <div className='text-center'>
                        Scan QR <br />
                        ประเมินความ <br />
                        พึงพอใจของอู่
                    </div>
                </div>    
            </div>
    )
  }

  renderFooter() {
    return(
      <div className='other-text'>
        เรียน ท่านเจ้าของรถ <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        โปรดกรุณาตรวจสอบ และนำสิ่งของมีค่าออกจากรถของท่าน หากเกิดการเสียหายหรือสูญหาย ทางบริษัทไม่สามารถรับผิดชอบใดๆทั้งสิ้น <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        ทางบริษัทอาจต้องนำรถของท่านไปทำการทดลองบนถนนในสภาวะการณ์จริง เพื่อทำการวิเคราะห์และตรวจสอบงานซ่อมหรือเพื่อให้ศูนย์บริการตรวจสอบอีกครั้ง
      </div>
    )
  }

  renderFooter1() {
      let {customer_permission} = this.state.related_detail_wcs
      return(
        <div className='text-center other-text'>
            <div>
                                <Checkbox
                                    onChange={this.onCustomerPermissionChange.bind(this,true)}
                                    checked={customer_permission?true:false}
                                    checkboxClass="icheckbox_minimal"
                                    increaseArea="20%"
                                    label={' ลูกค้าอนุมัติ'}
                                />
                                &nbsp;
                                <Checkbox
                                    onChange={this.onCustomerPermissionChange.bind(this,false)}
                                    checked={customer_permission===false?true:false}
                                    checkboxClass="icheckbox_minimal"
                                    increaseArea="20%"
                                    label={' ลูกค้าไม่อนุมัติ'}
                                />
            </div>
            <div className='other-text'>
                ข้าพเจ้าได้ตรวจสอบและนำสิ่งของมีค่าออกจากรถและยืนยันสภาพรถตามที่ระบุในเอกสารนี้
            </div>                        
        </div>        
      )
  }

  renderBody() {
    return(
      <div>
        {this.renderCheck()}
        <div className='footer-page'>
            {this.renderQRCode()}
        </div>
      </div>
    )
  }

  renderLogoUrl(logo){
    let logoWidth = logo.logo_width
    let logoUrl = logo.logo_url
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    if(logoUrl!==undefined)
      return (<img src={imgUrl} style={{width:logoWidth+'px'}}/>)
    else
      return ('')
  }

  renderComponentPage() {
    let {data} = this.state
    return(
      <div className='font-print'>
        <header></header>
        <article></article>
        <div className='wrap-wcs-check'>
            <div className='wcs-check-header text-center'>
                <span className='date text-left'>วันที่ {data.receiving!==undefined?<span>{data.receiving.contact_date}</span>:'......../......../........'}</span>
                <h4>{this.props.title}</h4>
            </div>
            <div className='wcs-check-header text-center'>
                <table className='table table-print-wcs-parking-car-doc' style={{marginBottom:'0'}}>
                    <tbody>
                        <tr>
                            <td style={{width:'25%'}}>รถยี่ห้อ <span>{data.car!==undefined?data.car.brand:''}</span></td>
                            <td style={{width:'25%'}}>รุ่น <span>{data.car!==undefined?data.car.model:''}</span></td>
                            <td style={{width:'25%'}}>สีรถ <span>{data.car!==undefined?data.car.car_color:''}</span></td>
                            <td style={{width:'25%'}}>หมายเลขทะเบียน <span>{data.car!==undefined?data.car.car_registration_no:''}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            {this.renderBody()}
        </div>
        <br />
        {this.renderFooter()}    
        {this.renderFooter1()}
        <br />
        <br />
        <br />
        {this.renderSignature()}
      </div>  
    )
  }

  render() {
    let {loading} = this.state
    return(
      <div>
        <PrintPreview 
            loading={loading}
            leftBarTitle={this.props.title}
        >
            {this.renderComponentPage()}
        </PrintPreview>
        <TextFieldModal 
          ref='milesFieldModal'
          confirmTitle='บันทึก'
          onConfirm={this.onMilesSave.bind(this)}
        />
        <TextFieldModal 
          ref='remarkFieldModal'
          confirmTitle='บันทึก'
          onConfirm={this.onRemarkSave.bind(this)}
        />
        <TextFieldModal 
          ref='subRemarkFieldModal'
          confirmTitle='บันทึก'
          onConfirm={this.onSubRemarkSave.bind(this)}
        />
        <NotificationSystem ref="notificationSystem" />
      </div>
    ) 
  }
}  

PrintWCSCheckingCarDoc.defaultProps = {
  title: 'ใบตรวจสภาพรถ (ก่อนการซ่อม และหลังการซ่อม)',  
  mode : '1'
}
export default PrintWCSCheckingCarDoc;


// WEBPACK FOOTER //
// ./src/view/print/wcs/PrintWCSCheckingCarDoc.js